<script>
import Vue from 'vue'
import Vuex from 'vuex'
import store from '@/globals'
import $ from 'jquery'

export default {
  name: 'App',
  data () {
    return {
      pastTitle: store.state.pastTitle
    }
  },
  // methods: {
  //   pagePicker(page){
  //     console.log('pagePicker running...')
  //     $('#content').addClass('animated fadeOut')
  //     const newUrl= "/" + page;
      
  //     setTimeout ( function () {
  //       // console.log('change!')
  //       window.location.hash = newUrl
  //     },1000)
  //   }
  // },
  render () {
    if (store.state.pastTitle === false) { 
      return (
        <div id="app">
          <router-view />
        </div>
      )
    } else {
      return (
        <div id="app" class="container-fluid animated fadeIn pastTitle">
          <span class="row">
            <div id = "sidebar" class="col-xs-12 col-sm-12 col-md-2 col-lg-2 bigDiv">
            {/*<div id = "sidebar" class="col-xs-12 col-sm-12 col-md-2 col-lg-2 bigDiv">*/}
              
              <div id = "logo" class = "topElements">
                <img id = "profilePic" class = "img-fluid rounded-circle" src = "/static/imgs/icon.jpg" />
                <img class = "img-fluid" src = "/static/imgs/EJ_Title4.png" />
              </div>

              <ul id = "navList" class="list-group animated slideInLeft">
                {/*<a onclick = { () => this.pagePicker }>
                  <li class="list-group-item menuItem" >Home</li>
                </a>
                <a click= { this.pagePicker }>
                  <li class="list-group-item menuItem" >About</li>                  
                </a>
                <a onclick = { this.pagePicker }>
                  <li class="list-group-item menuItem" >Portfolio</li>                  
                </a>
                <a onclick = { this.pagePicker }>
                  <li class="list-group-item menuItem" >Contact</li>                  
                </a>*/}
                
                <router-link to="/">
                  <li class="list-group-item menuItem topElements">Home</li>
                </router-link>

                <router-link to="/Profile">
                  <li class="list-group-item menuItem topElements">About</li>
                </router-link>

                <router-link to="/Portfolio">
                  <li class="list-group-item menuItem topElements">Portfolio</li>
                </router-link>

                <router-link to="/Contact">
                  <li class="list-group-item menuItem topElements">Contact</li>
                </router-link>

              </ul>
            </div>
            {/* <div id = "content" class="bigDiv"> */}
            <div id = "content" class="col-10 bigDiv">
              <router-view />
            </div>
          </span>
        </div>
      )
    }
  }
}
</script>

<style>
body{
  background-image: url('/static/imgs/wg_trianglify.png');
  background-repeat: repeat; 
  background-attachment: fixed;
  background-size: 100%;
  min-width: 415px;
}

.bigDiv{
  height: 650px;
}

.menuItem{  
  font-size: 25px;
  background-color: #292f36;
  color: #ff6b6b;
  border: transparent;
}

.menuItem:hover{
  background-color: #23282e;
  color: #4ecdc4;
}

.pastTitle {
  background-color: #292f36;
  min-height: 800px;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 750px;
}

#profilePic {
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}

#profilePic:hover {
  -webkit-filter: grayscale(0%); /* Safari 6.0 - 9.0 */
  filter: grayscale(0%);
}

#sidebar {
  background-color: #292f36;
}

@media screen and (max-width: 768px) {  
  .menuItem {
    width: 15%;
    font-size: 18px;
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 10px;
    padding-right:10px;
    margin-left: auto;
    margin-right: auto;
    top: 30px;
  }

  .bigDiv {
    height: 100px;
    width: 80%;
  }

  .topElements {
    width: 20%;
  }

  #app {
    background-color: transparent;
  }

  #content {
    display: contents;
    width: 100%;
    min-width: 400px;
  }

  #logo {
    width: 20%;
    height: auto;
    margin: 0px;
    z-index: 2;
  }

  #navList {
    flex-direction: row;
    width: 100%;
  }

  #profilePic {
    width: 82.475px;
  }

  #sidebar {
    display: inline-flex;
    width: 100%;
    min-width: 400px;
  }
}
@media screen and (min-width:768px) {
  
}
@media screen and (min-width: 992px) {
  .menuItem {
    padding: 15px;
  }

  #profileBody {
    padding-top: 50px!important;
  }
  
  #sidebar {
    min-height: 750px;
  } 
}
</style> 



// WEBPACK FOOTER //
// src/App.vue